import { styled } from 'goober';
import { forwardRef } from 'react';

export const DimensionSlicerButton = styled(
    'div',
    forwardRef
)<{ $active?: boolean }>(({ theme, $active }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    outline: 'none',
    borderRadius: '5px',
    backgroundColor: theme.colors.neutral.w50,
    border: $active ? `1px solid ${theme.colors.primary.w500}` : '1px solid transparent',
    position: 'relative',
    cursor: 'pointer',
    padding: '0px 8px',
    fontSize: '10px',
}));

export const DimensionSlicerButtonTitle = styled('span')<{ $active?: boolean }>(({ theme, $active }) => ({
    margin: 0,
    fontSize: '12px',
    color: $active ? theme.colors.primary.w500 : theme.colors.ui.dark,
    textAlign: 'center',
    fontWeight: 'normal',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
}));

export const SingleValueData = styled('div')(({ theme }) => ({
    fontSize: '46px',
    fontWeight: 'bold',
    color: theme.colors.ui.dark,
    marginTop: '-8px',
}));

export const SingleValueDataInputContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginTop: '-6px',
}));

export const SingleValueDataInput = styled('input')(({ theme }) => ({
    fontSize: '46px',
    fontWeight: 'bold',
    color: theme.colors.ui.dark,
    background: 'none',
    border: 'none',
    outline: 'none',
    width: '100%',
    padding: '0px',
}));

export const SingleValueDataInputButtonContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    paddingTop: '6px',
    marginBottom: '-6px',
}));

export const SingleValueComparisonData = styled('div')(() => ({
    fontSize: '12px',
    lineHeight: 1.6,
    marginTop: '2px',
}));

export const SingleValueComparisonNumber = styled('span')<{ $positive?: boolean }>(({ theme, $positive = true }) => ({
    padding: '4px 8px',
    borderRadius: '20px',
    fontWeight: 500,
    backgroundColor: $positive ? theme.colors.success.w50 : theme.colors.error.w50,
    color: $positive ? theme.colors.success.w500 : theme.colors.error.w500,
}));
